import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import Header from './Header';
import InstantVoiceCloningOption from './InstantVoiceCloning';
import ProVoiceCloningOption from './ProVoiceCloning';
import DemoCloningResults from './DemoCloningResults';
import {
  StyledContentWrapper,
  StyledVoiceCloningHome,
  StyledVoiceCloningOptionWrapper,
  StyledVoiceCloningDemoWrapper,
  StyledVoiceCloningDemoTitle,
} from './index.style';

const Home = ({
  handleOpenPopupInstantVoiceCloning,
  handleOpenPopupProfessionalVoiceCloneUpload,
}) => {
  const { t } = useTranslation();

  return (
    <StyledVoiceCloningHome>
      <Header />

      <StyledContentWrapper>
        <StyledVoiceCloningOptionWrapper>
          <InstantVoiceCloningOption
            handleOpenPopupInstantVoiceCloning={
              handleOpenPopupInstantVoiceCloning
            }
          />
          <ProVoiceCloningOption
            handleOpenPopupProfessionalVoiceCloneUpload={
              handleOpenPopupProfessionalVoiceCloneUpload
            }
          />
        </StyledVoiceCloningOptionWrapper>

        <StyledVoiceCloningDemoWrapper>
          {/* Demo title */}
          <StyledVoiceCloningDemoTitle>
            <Typography variant="body-16-medium" color={COLOR.label2[64]}>
              {t('voiceCloningDemoTitle')}
            </Typography>
          </StyledVoiceCloningDemoTitle>

          {/* Demo results */}
          <DemoCloningResults />
        </StyledVoiceCloningDemoWrapper>
      </StyledContentWrapper>
    </StyledVoiceCloningHome>
  );
};

export default Home;
